import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/vialidades`;

export const TIPOS_ATENCION = [
  "ORDINARIO", "CRC", "OFICIO", "EVENTO", "ALCALDE", "REGIDOR",
  "DIRECTOR DMU", "SUBDIRECTOR ESPACIOS PÚBLICOS", "DESPACHO",
  "CONSERJE", "AVANZADA ALCALDE",
  "EMERGENCIA", "DESASTRE NATURAL", "APOYO VIAL POR ACCIDENTE",
];
export const TIPOS_ORIGEN_OBLIGATORIO = new Set([
  "ALCALDE", "REGIDOR", "DIRECTOR DMU", "SUBDIRECTOR ESPACIOS PÚBLICOS",
  "DESPACHO", "CONSERJE", "AVANZADA ALCALDE",
]);
export const TIPOS_COORD_OBLIGATORIA = new Set([
  "CRC", "OFICIO", "ALCALDE", "REGIDOR", "DIRECTOR DMU",
  "SUBDIRECTOR ESPACIOS PÚBLICOS", "DESPACHO", "CONSERJE", "AVANZADA ALCALDE",
]);
export const TURNOS = ["PRIMER TURNO", "SEGUNDO TURNO", "TERCER TURNO", "TIEMPO EXTRA"];
export const AREAS = [
  "VIALIDAD", "PARQUES", "PUENTES", "EDIFICIOS PÚBLICOS", "ESCUELAS",
  "CORREDOR O ANDADOR", "CENTROS COMUNITARIOS", "DEPORTIVOS O CANCHAS",
  "MONUMENTOS", "DOMICILIO", "POR ADM.",
];
export const TIPOS_FRENTE = ["UN LADO", "AMBOS LADOS", "CAMELLÓN CENTRAL", "CAMELLÓN + AMBOS LADOS"];
export const ACTIVIDADES = [
  "LIMPIEZA GENERAL", "RETIRO DE BASURA Y ESCOMBRO",
  "APLICACIÓN DE QUÍMICOS", "RESIDUOS POR ACCIDENTE VIAL",
  "LIMPIEZA ESPECIAL",
];

export const calcBasura = (bolsas) => {
  const n = Number(bolsas) || 0;
  const kg = n * 25;
  return { bolsas: n, kg, toneladas: +(kg / 1000).toFixed(3) };
};

export const calcML = (tipo_frente, metros_largo) => {
  const mult = { "UN LADO": 1, "AMBOS LADOS": 2, "CAMELLÓN CENTRAL": 1, "CAMELLÓN + AMBOS LADOS": 3 }[tipo_frente];
  if (!mult || !metros_largo) return null;
  return +(Number(metros_largo) * mult).toFixed(2);
};

export const listarActividades = (params = {}) =>
  axios.get(`${API}/actividades`, { params }).then(r => r.data);

export const crearActividad = (payload) =>
  axios.post(`${API}/actividades`, payload).then(r => r.data);

export const detalleActividad = (id) =>
  axios.get(`${API}/actividades/${id}`).then(r => r.data);

export const editarActividad = (id, payload) =>
  axios.put(`${API}/actividades/${id}`, payload).then(r => r.data);

export const eliminarActividad = (id) =>
  axios.delete(`${API}/actividades/${id}`).then(r => r.data);

export const registrarGPS = (id, lat, lng) =>
  axios.put(`${API}/actividades/${id}/gps`, { gps_lat: lat, gps_lng: lng }).then(r => r.data);

export const subirFoto = (id, slot, data_url) =>
  axios.post(`${API}/actividades/${id}/foto`, { slot, data_url }).then(r => r.data);

export const importarExcel = (file, dry_run = true) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API}/importar-excel?dry_run=${dry_run}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then(r => r.data);
};

// Comprime un File de imagen a dataURL JPEG ≤ 1024px lado largo.
export const compressFile = (file, maxDim = 1024, quality = 0.7) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = (ev) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      const ratio = Math.min(maxDim / width, maxDim / height, 1);
      width = Math.round(width * ratio);
      height = Math.round(height * ratio);
      const c = document.createElement("canvas");
      c.width = width; c.height = height;
      c.getContext("2d").drawImage(img, 0, 0, width, height);
      resolve(c.toDataURL("image/jpeg", quality));
    };
    img.onerror = reject;
    img.src = ev.target.result;
  };
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

export const dashboard = (params = {}) =>
  axios.get(`${API}/dashboard`, { params }).then(r => r.data);

export const listarParques = (q = "") =>
  axios.get(`${API}/parques`, { params: q ? { q } : {} }).then(r => r.data);

export const crearPrograma = (fecha, entradas) =>
  axios.post(`${API}/programa`, { fecha, entradas }).then(r => r.data);

export const listarPrograma = (params = {}) =>
  axios.get(`${API}/programa`, { params }).then(r => r.data);

export const editarPrograma = (id, body) =>
  axios.put(`${API}/programa/${id}`, body).then(r => r.data);

export const eliminarPrograma = (id) =>
  axios.delete(`${API}/programa/${id}`).then(r => r.data);

export const equipo = () =>
  axios.get(`${API}/equipo`).then(r => r.data);

export const exportarExcelURL = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return `${API}/exportar-excel${qs ? "?" + qs : ""}`;
};
export const exportarPDFURL = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return `${API}/exportar-pdf${qs ? "?" + qs : ""}`;
};
